import React, { FC, memo } from 'react';
import {
    M132ProductSetDetailModule,
    ProductSetViewModel,
} from '~/lib/data-contract';

import { ProductErrorResponse } from '~/shared/utils/product/data-models';
import ProductSetDetails from './product-set-details.component';
import { useProductSet } from '~/shared/utils/product/hooks/use-product-set';
import ProductErrorPage from '../product-error-page/product-error-page.component';

type Props = M132ProductSetDetailModule;

const ProductSetDetailDataWrapper: FC<Props> = memo((props) => {
    const { data } = useProductSet();

    if (!data) return null;

    if ((data as ProductErrorResponse).statusCode === 404) {
        return <ProductErrorPage {...(data as ProductErrorResponse)} />;
    }

    return <ProductSetDetails productSet={data as ProductSetViewModel} {...props} />;
});

ProductSetDetailDataWrapper.displayName = 'ProductSetDetailDataWrapper';
export default ProductSetDetailDataWrapper;
